var map = {
	"./reflection/bg/bg-1_sm.png": 36139,
	"./reflection/bg/bg-2_sm.png": 71622,
	"./reflection/bg/bg-3_sm.png": 38821,
	"./reflection/bg/bg-4_sm.png": 67648,
	"./reflection/bg/bg-5_sm.png": 19687,
	"./reflection/bg/bg-6_sm.png": 62930,
	"./reflection/bg/bg-7_sm.png": 8081
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90112;